import { render, staticRenderFns } from "./SOV4.vue?vue&type=template&id=62146916&scoped=true"
import script from "./SOV4.vue?vue&type=script&lang=js"
export * from "./SOV4.vue?vue&type=script&lang=js"
import style0 from "./SOV4.vue?vue&type=style&index=0&id=62146916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62146916",
  null
  
)

export default component.exports